module.exports = __webpack_public_path__ + "img/health3_7-9-2021.e43ee8d2.jpg";